import { Stack } from "expo-router";
import { StyleSheet } from "react-native";
import WebView from "react-native-webview";
import { useTheme } from "~/providers/ThemeProvider";

export type WebPageProps = {
    title: string;
    uri: string;
};

export const WebPage = ({ uri, title }: WebPageProps) => {
    const { background } = useTheme();

    return (
        <>
            <Stack.Screen
                options={{
                    headerTransparent: false,
                    headerStyle: background.primary,
                    title,
                }}
            />
            <WebView style={styles.container} source={{ uri }} />
        </>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
